export default "__VITE_ASSET__Hn8xu4Br__"